<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  },

})

const height = computed(() => props.height)
const width = computed(() => props.height / 40 * 57)
</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 57 40" xml:space="preserve" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,-1,-2)">
        <path d="M37.218,2C26.063,2 17.226,10.782 17.226,21.548C17.226,32.313 26.208,41.096 37.218,41.096C48.229,41.096 57.211,32.313 57.211,21.548C57.356,10.782 48.229,2 37.218,2ZM37.218,28.772C33.162,28.772 29.685,25.514 29.685,21.548C29.685,17.582 33.017,14.324 37.218,14.324C41.42,14.324 44.752,17.582 44.752,21.548C44.607,25.514 41.42,28.772 37.218,28.772Z" style="fill:rgb(139,63,253);fill-rule:nonzero;"/>
      <path d="M17.226,7.808L17.226,36.28L10.127,36.28L1,7.808L17.226,7.808Z" style="fill:rgb(139,63,253);fill-rule:nonzero;"/>
    </g>
</svg>

</template>

<style scoped lang="less">

</style>
